import React from "react";
import { Link } from "react-router-dom";


/*
==============
Page Not Found
==============
*/


const PageNotFound = () => {
  return (
    <>
      {/* Navbar */}
      {/* <Navbar /> */}
      <div className="container my-3 py-3">
        <div className="container">
          <div className="row">
            <div className="col-md-12 py-5 bg-light text-center">

              {/* Header */}
              <h4 className="p-3 display-5">404: Page Not Found</h4>

              {/* Link To Home */}
              <Link to="/" className="btn  btn-outline-dark mx-4 graphic2 btn-2 p-2">
                <i className="fa fa-arrow-left "></i> Go Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
